<template>
  <sc-page-base
    :loading="loading"
    :title="title">
    <div class="columns">
      <div class="column">
        <sc-tabs type="is-boxed has-form" v-model="typeId">
          <sc-tab-item label="Todos">
            <sc-quoting-return-all return-mode-type="ALL" :type-id="1"/>
          </sc-tab-item>
          <sc-tab-item label="Filtros">
            <sc-quoting-return-filter return-mode-type="USER_DEFINED" :type-id="2"/>
          </sc-tab-item>
          <sc-tab-item label="Fixos">
            <sc-quoting-return-fixed return-mode-type="FIXED_METHOD" :type-id="3"/>
          </sc-tab-item>
          <sc-tab-item label="Misto">
            <sc-quoting-return-mixed return-mode-type="MIXED" :type-id="4"/>
          </sc-tab-item>
          <sc-tab-item label="Modo Detalhado">
            <sc-quoting-return-detail return-mode-type="COMPLEX" :type-id="5"/>
          </sc-tab-item>
          <sc-tab-item label="Condições Customizadas">
            <sc-quoting-return-custom-condition return-mode-type="CUSTOM_CONDITION" :type-id="6"/>
          </sc-tab-item>
        </sc-tabs>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScPageBase,
    ScTabs,
    ScTabItem,
  } from '@intelipost-js/secure-components';
  import ScQuotingReturnAll from './components/sc-quoting-return-all/ScQuotingReturnAll.vue';
  import ScQuotingReturnFilter from './components/sc-quoting-return-filter/ScQuotingReturnFilter.vue';
  import ScQuotingReturnFixed from './components/sc-quoting-return-fixed/ScQuotingReturnFixed.vue';
  import ScQuotingReturnMixed from './components/sc-quoting-return-mixed/ScQuotingReturnMixed.vue';
  import ScQuotingReturnDetail from './components/sc-quoting-return-detail/ScQuotingReturnDetail.vue';
  import ScQuotingReturnCustomCondition from './components/sc-quoting-return-custom-condition/ScQuotingReturnCustomCondition.vue';

  const { mapState, mapActions } = createNamespacedHelpers('quote/quotingReturn');
  export default {
    name: 'page-quoting-return',
    data() {
      return {
        title: 'Resultados disponíveis na api',
        typeId: 0,
      };
    },
    computed: {
      ...mapState([
        'loading',
      ]),
    },
    methods: {
      ...mapActions([
        'getQuotingReturns',
      ]),
    },
    created() {
      this.$store.dispatch('logisticProviders/getLogisticProviders');
      this.getQuotingReturns().then(({ quotingReturnApi = {} }) => {
        this.typeId = quotingReturnApi.type_id - 1;
      });
    },
    components: {
      ScPageBase,
      ScTabs,
      ScTabItem,
      ScQuotingReturnAll,
      ScQuotingReturnFilter,
      ScQuotingReturnFixed,
      ScQuotingReturnMixed,
      ScQuotingReturnDetail,
      ScQuotingReturnCustomCondition,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/PageQuotingReturn.vue?0de4180e